import useFeatureFlag from '../../hooks/useFeatureFlag'
import DownloadCrewSchedules from './DownloadCrewSchedules'
import { useScheduleHeaderActions } from './ScheduleHeaderActionsContext'
import { CREW_DAY_SCHEDULES_FEATURE, ScheduleMode } from './scheduleModel'

const ScheduleHeaderActions = () => {
  const { headerState } = useScheduleHeaderActions()
  const crewDaySchedulesEnabled = useFeatureFlag(CREW_DAY_SCHEDULES_FEATURE)

  if (!crewDaySchedulesEnabled) {
    return null
  }

  if (headerState === null || headerState.view !== ScheduleMode.Day) {
    return null
  }

  return <DownloadCrewSchedules selectedDate={headerState.selectedDate} />
}

export default ScheduleHeaderActions
